import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class ContractSearchModel extends BaseModel {
  filename = null;
  status = null;
  sent_date = null;
  sent_date_date_range = {};

  attributeLabels = {
    filename: i18n.t('Filename')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (data.sent_date_date_range && data.sent_date_date_range.startDate && data.sent_date_date_range.endDate) {
      data.sent_date_after = moment(data.sent_date_date_range.startDate).format(SYSTEM_DATE_FORMAT);
      data.sent_date_before = moment(data.sent_date_date_range.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.sent_date_date_range
    delete data.sent_date

    return data;
  }

  getFilteredData() {
    const data = this.toJSON();
    return data;
  }
}
